import { REGISTER_PS, REGISTER_CPS } from './const.js'

export const register = {
    uppercase: 'Uppercase Letter',
    lowercase: 'Lowercase Letter',
    symbol: 'Special Symbol',
    digital: 'Digital',
    '8bit': '8-bit',
    repeatPwdError: 'The two passwords entered are inconsistent',
    show: 'SHOW',
    hide: 'HIDE',
    pageTitle: 'Intelligent Business Analytics',
    register: 'Register',
    pwd: REGISTER_PS,
    cPwd: REGISTER_CPS,
    phoneNumber: 'International Phone Number',
    phoneNumberTip: '(Example input: In the case of 09012345678, enter +819012345678)',
    submit: 'Submit',
    noEmailError: 'Missing the necessary registration parameters (Email, orgId or registrationToken)',
    registedError: 'You are already registered, please go directly to the login page to login',
    phoneNumberError: 'The phone number format is incorrect.'
}
